<template>
  <v-container>
    <v-tabs>
      <template v-if='$store.getters.loggedIn==true'>
        <v-tab to='/admin/editsite'>サイト情報</v-tab>
        <v-tab to='/admin/editnews'>日々のコラム</v-tab>
        <v-tab to='/admin/editservice'>サービス</v-tab>
        <v-tab to='/admin/editsales'>販売商品</v-tab>
        <v-tab to='/admin/editrecord'>開発事例</v-tab>
        <v-tab to='/admin/editqanda'>よくある質問</v-tab>
        <v-tab to='/admin/editcomment'>お客様の声</v-tab>
        <v-tab to='/admin/checkinquiry'>問い合わせ確認</v-tab>
        <v-tab to='/admin/editpolicy'>プライバシーポリシー</v-tab>
        <v-spacer></v-spacer>
        <v-tab @click='onClickログアウト()'>ログアウト</v-tab>
      </template>
      <template v-else>
        <v-spacer></v-spacer>
        <v-tab  to='/admin/login'>ログイン</v-tab>
      </template>
    </v-tabs>
  </v-container>
  <router-view></router-view>

</template>
<script>
export default {
  mounted(){
    if(this.$store.getters.loggedIn==false){
      this.$router.push({
        path:"/admin/login",
        query:{redirect:"/admin"},
      });
    }
  },
  methods:{
    onClickログアウト(){
      this.$store.commit("logout");
      this.$router.push({
        path:"/admin/login",
        query:{redirect:"/admin"},
      });
    }
  }
}
</script>